/**
 * Logger Utility - Production-safe logging
 *
 * In production (NODE_ENV === 'production'), all logs are suppressed.
 * In development, logs are output normally.
 *
 * Usage:
 *   import logger from '../utils/logger';
 *   logger.log('Normal log');
 *   logger.debug('Debug info');
 *   logger.info('Info message');
 *   logger.warn('Warning');
 *   logger.error('Error'); // Errors are always logged
 */

const isDev = process.env.NODE_ENV !== 'production';

const logger = {
  log: (...args) => {
    if (isDev) console.log(...args);
  },

  debug: (...args) => {
    if (isDev) console.debug(...args);
  },

  info: (...args) => {
    if (isDev) console.info(...args);
  },

  warn: (...args) => {
    if (isDev) console.warn(...args);
  },

  // Errors are always logged (important for debugging production issues)
  error: (...args) => {
    console.error(...args);
  },

  // Group logs (only in dev)
  group: (...args) => {
    if (isDev) console.group(...args);
  },

  groupEnd: () => {
    if (isDev) console.groupEnd();
  },

  // Table output (only in dev)
  table: (...args) => {
    if (isDev) console.table(...args);
  }
};

export default logger;
